type ClipboardActions = {
  onErrorAction?: () => void
  onSuccessAction?: () => void
}

export const copyToClipboard = async (
  text: string,
  { onSuccessAction, onErrorAction }: ClipboardActions = {},
): Promise<void> => {
  const { isSecureContext } = window
  const isClipboardAvailable = window.navigator?.clipboard

  try {
    if (!isSecureContext || !isClipboardAvailable) {
      throw new Error('Clipboard API is not supported in your browser.')
    }

    await navigator.clipboard.writeText(text)

    onSuccessAction && onSuccessAction()
  } catch (error) {
    onErrorAction && onErrorAction()

    throw new Error(String(error))
  }
}
